import {Component, Inject, Input, OnInit} from '@angular/core';
import {BUTTON_SUB_TYPE, LibButtonComponent} from "../../../../tal-library/button/lib-button/lib-button.component";
import {ROUTE} from "../../common/constant/routing.constant";
import {interval} from "rxjs";
import {RichTextSanitizerUtil} from "../common/util/rich-text-sanitizer.util";
import {DomSanitizer} from "@angular/platform-browser";
import {Router} from "@angular/router";
import {MAT_SNACK_BAR_DATA, MatSnackBarRef} from "@angular/material/snack-bar";
import {NotificationUtil} from '../common/util/notification.util';
import {MatProgressBar} from "@angular/material/progress-bar";
import {animate, style, transition, trigger} from "@angular/animations";
import {NOTIFICATION_EVENT_TYPE, NotificationOutDto, NotificationService} from "../common/service/notification.service";
import {DateUtil} from 'src/app/talenlio-hireos/common/util/date-util';

@Component({
    selector: 'tal-notification-snackbar',
    standalone: true,
    imports: [
        LibButtonComponent,
        MatProgressBar
    ],
    templateUrl: './notification-snackbar.component.html',
    styleUrl: './notification-snackbar.component.scss',
    animations: [
        trigger('slideInAnimation', [
            // Enter transition - when element is inserted into DOM
            transition(':enter', [
                style({right: '-1000px', opacity: 0}), // Element starts outside the viewport
                animate('500ms ease-in-out', style({right: '0px', opacity: 1})) // Animates to the right position and fades in
            ]),
            // Optional leave transition - when element is removed from DOM
            transition(':leave', [
                animate('500ms ease-in-out', style({right: '-1000px', opacity: 0})) // Slide out and fade out
            ])
        ])
    ]
})
export class NotificationSnackbarComponent implements OnInit {

    @Input()
    notificationOutDto: NotificationOutDto = this.snackbarData?.data;

    progressValue = 100;
    remainingTime = 0;
    timeout = this.snackbarData?.timeout || 5000;
    protected readonly DateUtil = DateUtil;
    protected readonly NotificationUtil = NotificationUtil;
    protected readonly BUTTON_SUB_TYPE = BUTTON_SUB_TYPE;

    constructor(@Inject(MAT_SNACK_BAR_DATA) public snackbarData: any,
                private snackBarRef: MatSnackBarRef<NotificationSnackbarComponent>,
                private router: Router,
                private sanitizer: DomSanitizer,
                private notificationService: NotificationService) {
    }

    ngOnInit(): void {
        this.setNotificationTimeout();
    }

    sanitizeNotification(htmlString: string): string {
        if (!htmlString) {
            return '';
        }
        return RichTextSanitizerUtil.getSanitizedHtml(htmlString, this.sanitizer) ?? htmlString;
    }

    redirect(notificationOutDto: NotificationOutDto): void {
        switch (notificationOutDto?.notificationEventType) {
            case NOTIFICATION_EVENT_TYPE.CHAT_MESSAGE:
                this.redirectToConversation(notificationOutDto);
                break;
        }
    }

    private redirectToConversation(notificationOutDto: NotificationOutDto): void {
        if (!notificationOutDto?.conversationId) {
            return;
        }
        this.router.navigate([ROUTE.INBOX, ROUTE.MESSAGES, notificationOutDto.conversationId]).then(() => {
            this.snackBarRef.dismiss();
        });
    }

    private markAsRead(notificationOutDto: NotificationOutDto, userId: string): void {
        this.markNotificationAsRead(notificationOutDto, userId);
        this.snackBarRef.dismiss();
    }

    private markNotificationAsRead(notificationOutDto: NotificationOutDto, userId: string): void {
        this.notificationService.markOneAsRead(userId, notificationOutDto.id).then(() => {
        });
    }

    private setNotificationTimeout(): void {
        const timer$ = interval(100);
        const sub = timer$.subscribe((remainingTime) => {
            this.progressValue = 100 - remainingTime * 10000 / this.timeout;
            this.remainingTime = remainingTime;
            if (this.progressValue === 0) {
                sub.unsubscribe();
            }
        });
    }
}
